const Joi = require("joi");

const PostalMailSchema = (data) => {
  const schema = Joi.object({
    // Dropdown for facilityCode - assuming it's an alphanumeric value
    FacilityCode: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .required()
      .messages({
        "string.pattern.base": "Please choose Facility Code.",
        "any.required": "Please choose Facility Code.",
        "string.empty": "Please choose Facility Code.",
      }),

    InmateID: Joi.number().min(1).required().messages({
      "number.min": "Please choose Inmate.",
      "number.base": "Please choose Inmate.",
      "any.required": "Please choose Inmate.",
    }),

    // File upload for mailDocument - only allow PDF
    DocumentName: Joi.string()
      .custom((value, helpers) => {
        // Check if the file is a .pdf (checking both extension and basic MIME type)
        if (!value.endsWith(".pdf")) {
          return helpers.message("The uploaded file must be a PDF.");
        }
        return value;
      })
      .required()
      .messages({
        "any.required": "Please upload Document.",
        "string.empty": "Please upload Document.", // When the field is an empty string
      }),
  }).unknown(true); // This allows extra properties to exist in the object without validation.

  return schema.validate(data, {
    abortEarly: false, // This ensures that all validation errors are reported, not just the first one.
  });
};

module.exports = PostalMailSchema;
